/**
 * Generate a new name for a whiteboard.
 *
 * @param itemName - The name of the item
 * @param whiteboards - The list of whiteboards
 * @returns The new name
 */
export const generateNewName = (itemName: string, whiteboards: string[]) => {
	let newName = itemName;
	let counter = 0;
	while (whiteboards.some((wb) => wb === newName)) {
		const counterString = counter > 0 ? ` (${counter})` : "";
		newName = `Copy of ${itemName}${counterString}`;
		counter++;
	}
	return newName;
};

/**
 * Generate a new name for a template-based whiteboard.
 *
 * @param template - The template object
 * @param whiteboards - The list of whiteboard names
 * @returns The new name with "My " prefix and number suffix if duplicate exists
 */
export const generateTemplateName = (
	template: { displayName: string },
	whiteboards: string[],
) => {
	const baseName = `My ${template.displayName}`;
	let newName = baseName;
	let counter = 1;
	while (whiteboards.some((wb) => wb === newName)) {
		newName = `${baseName} (${counter})`;
		counter++;
	}
	return newName;
};
